import { render, staticRenderFns } from "./usersdetails.vue?vue&type=template&id=dc22fd3a"
import script from "./usersdetails.vue?vue&type=script&lang=js"
export * from "./usersdetails.vue?vue&type=script&lang=js"
import style0 from "./usersdetails.vue?vue&type=style&index=0&id=dc22fd3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports